// src/components/ErrorPage.jsx
const ErrorPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        padding: "2rem",
        background: "#ffffff",
      }}
    >
      <h1>Something went wrong!</h1>
      <p>
        Oops! An unexpected error occurred. Please try again later.
      </p>
    </div>
  );
};

export default ErrorPage;
